import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';

import { withAccount } from '../../components/AccountContext';
import Respondents from './Respondents';
import { parse, filterPaginationWithSize, emptyConnection } from '../../utils/UrlUtil';

export const RESPONDENTS_QUERY = gql`
  query(
    $accountId: ID!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $filter: RespondentFilter
    $sort: RespondentSortSpecifier
  ) {
    # Query for respondents
    account(id: $accountId) {
      id
      respondents(first: $first, after: $after, last: $last, before: $before, filter: $filter, sort: $sort) {
        totalCount
        indexFrom
        indexTo
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
        edges {
          cursor
          node {
            id
            firstName
            lastName
            email
            type
            updatedOn
          }
        }
      }
    }
  }
`;

class RespondentsContainer extends Component {
  static propTypes = {
    location: PropTypes.objectOf(PropTypes.any).isRequired,
    currentAccount: PropTypes.number.isRequired,
  };

  render() {
    const { currentAccount, location } = this.props;
    const params = parse(location.search);
    const pagination = filterPaginationWithSize(params);

    const variables = {
      ...pagination,
      accountId: currentAccount,
      sort: params.sort || { sortBy: 'updatedOn', sortDir: 'DESC' },
      filter: params.filter,
    };
    return (
      <Query query={RESPONDENTS_QUERY} variables={variables} fetchPolicy="network-only">
        {({ data, loading, error }) => {
          if (error) return `Error! ${error.message}`;

          const respondents = data && data.account ? data.account.respondents : emptyConnection();

          return <Respondents respondents={respondents} currentAccount={currentAccount} loading={loading} />;
        }}
      </Query>
    );
  }
}

RespondentsContainer.propTypes = {
  currentAccount: PropTypes.string.isRequired,
};

export default withRouter(injectIntl(withAccount(RespondentsContainer)));
